/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { connect } from 'react-redux'
import React, { useEffect, useRef, useState } from 'react'
import { useMsal } from '@azure/msal-react'
import { Button } from 'antd'
import { isMsAuthEnabled } from './utils'
import useTokensGetterTask from './useTokensGetterTask'
import { getMSAuthConfig } from '../api/pgads'
// import Cookies from 'js-cookie'
// import { cookieName } from '../utils'
import { getApiTargetInfo } from 'core'
import * as actions from 'core/actions'

// const extractJwtFromResponse = respText =>
//   cookieName != null ? Cookies.get(cookieName) : respText

export const MsLogin = ({ mode = 'fullscreen', targetInfo }) => {
  const { instance, inProgress } = useMsal()
  console.log('progress is', inProgress)
  const [msAuthTexts, setMsAuthTexts] = useState({
    MS_AUTH_LOGIN_BUTTON_LABEL: 'Sign In With Azure AD',
    MS_AUTH_LOGIN_BUTTON_EXTRA: '',
  })
  useEffect(() => {
    if (window.location.pathname !== '/') {
      window.location.href = '/'
    }
    getMSAuthConfig(targetInfo).fork(console.log, setMsAuthTexts)
  }, [targetInfo])
  const css =
    mode === 'fullscreen'
      ? {
          width: '100vw',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }
      : {
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }
  return (
    <div
      css={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div>
        <Button
          loading={inProgress !== 'none'}
          type="primary"
          onClick={() => {
            instance.loginPopup().then(resp => {
              console.log(resp)
            })
          }}
        >
          {(msAuthTexts || {}).MS_AUTH_LOGIN_BUTTON_LABEL ||
            'Sign In With Azure AD'}
        </Button>
        {/* {(msAuthTexts || {}).MS_AUTH_LOGIN_BUTTON_EXTRA && (
          <div>{msAuthTexts.MS_AUTH_LOGIN_BUTTON_EXTRA}</div>
        )} */}
        {(msAuthTexts || {}).MS_AUTH_LOGIN_BUTTON_EXTRA && (
          <div
            style={{ marginTop: '10px' }}
            dangerouslySetInnerHTML={{
              __html: msAuthTexts.MS_AUTH_LOGIN_BUTTON_EXTRA,
            }}
          />
        )}
      </div>
    </div>
  )
}

const MsAuthenticated = ({ targetInfo, convertIdToken, children }) => {
  const { accounts } = useMsal()

  const [getTokens] = useTokensGetterTask()
  // console.log('get token', getTokens)

  // console.log('progress is', inProgress)
  // console.log('accounts is', accounts)
  const account = accounts[0]
  const accountRef = useRef(null)

  const { baseUrl, fetchCredentials } = targetInfo
  // console.log('targetInof is', targetInfo)
  // const fetchCredentials = fetchTaskCredentials
  // const targetInfoRef = useRef(targetInfo)
  // useEffect(() => {
  //   targetInfoRef.current=
  // })

  useEffect(() => {
    if (account !== accountRef.current && account != null) {
      console.log('should silent log into ', account, ' with ', getTokens)
      getTokens(account).fork(
        e => {
          console.error('got error acquiring token', e)
        },
        tokens => {
          // if (tokens != null) {
          console.log('token payload is', tokens)
          convertIdToken(tokens.idToken)
          // convertIdToken({ baseUrl, fetchCredentials })(tokens.idToken).fork(
          //   e => {
          //     console.log('got error', e)
          //   },
          //   jwt => {
          //     saveJwt(extractJwtFromResponse(jwt))
          //   }
          // )
          // }
        }
      )
    }
    accountRef.current = account
  }, [account, baseUrl, fetchCredentials, getTokens, convertIdToken])

  if (!isMsAuthEnabled) return children
  return accounts.length > 0 ? children : <MsLogin targetInfo={targetInfo} />
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})

const mapDispatchToProps = dispatch => ({
  convertIdToken: jwt => dispatch(actions.convertIdToken(jwt)),
})

export default connect(mapStateToProps, mapDispatchToProps)(MsAuthenticated)
